import {useEffect, useState} from 'react';
import {Dialog} from '@mui/material';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import styles from 'assets/css/version.module.css';
import Logo from 'assets/img/version-logo.svg';

const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 8px;
    width: 315px;
    background: #f5f5f5;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 26px 24px 34px;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }
`;

const VersionModal = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = (event) => {
    const versionData = JSON.parse(event?.data);

    if (versionData.state === 'getversion') {
      const osResult = versionData?.platform === 'android' ? 'android' : 'ios';
      const checkVersion =
        +versionData.version !== +process.env.REACT_APP_NATIVE_VERSION;

      if (checkVersion && osResult === 'android') {
        setOpen(true);
      }
    }
  };

  useEffect(() => {
    window?.ReactNativeWebView?.postMessage('getversion');
    document.addEventListener('message', handleOpen);
    window.addEventListener('message', handleOpen);
    return () => {
      document.removeEventListener('message', handleOpen);
      window.removeEventListener('message', handleOpen);
    };
  }, []);

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <CustomizedDialog
      open={open}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <p className={styles.header}>به روز رسانی</p>
      <img src={Logo} alt='' className={styles.img} />
      <p className={styles.text}>
        برای استفاده از همه امکانات، لازم است آخرین نسخه را نصب کنید
      </p>
      <Button
        className={styles.btn}
        onClick={() => openInNewTab('https://freesens.ir')}>
        نصب آخرین نسخه از وب سایت
      </Button>
    </CustomizedDialog>
  );
};
export default VersionModal;
